import React from 'react'
import { connect } from 'react-redux'
import allRoles from '../../roles/roles'
import {
    addListItem, changeListItem, deleteListItem, getListFromValues,
    hasChangedValues, getFormValue, changeItemsValue, nullDate
} from '../../public/utility'
import { doGetLogin, doSaveLogin, doDeleteLogin } from '../../reducers/actions'

class PersonLoginDetail extends React.Component {
    state = {
    }

    componentDidMount = () => {
        this.doGetLogin()
    }

    doGetLogin = () => {
        const { dispatch, id, personID } = this.props

        dispatch(doGetLogin({
            id: id || 0,
            personID: personID || 0,
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ id, personID, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        }))
    }

    handlerSave = () => {
        const { dispatch, onClose, onRefresh } = this.props
        const { id, personID, initValues基本信息, changedValues基本信息, } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }

        dispatch(doSaveLogin({
            id: id || 0,
            personID: personID || 0,
            changedValues基本信息,
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    onRefresh && onRefresh()
                    onClose && onClose()
                }
            }
        }))
    }

    handlerDelete = () => {
        const { dispatch, onClose, onRefresh } = this.props
        const { id } = this.state

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeleteLogin({
                id: id || 0,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onRefresh && onRefresh()
                        onClose && onClose()
                    }
                }
            }))
        )
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        return this.bChanged() && getFormValue(this, '基本信息', '帐号')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }


    fieldset基本信息 = () => {
        return [
            { _text: '帐号', required: true, minWidth: '50%' },
            { _text: '登录密码', minWidth: '50%', password: true },
            { _text: '企业微信帐号', minWidth: '90%' },
            { _checkbox: '角色', itemMinWidth: 125 },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, bReadOnly } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state

        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} maxWidth="700"
            controls={
                bReadOnly && [{ _button: '关闭', icon: 'close', handler: this.handlerClose }] ||
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave() },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(PersonLoginDetail)